import Meta from 'vue-meta'

export default {
  install (Vue) {
    Vue.component(
      'tema-farsoft',
      () => import('../containers/layouts/tema-farsoft')
    )

    Vue.use(Meta, {
      keyName: 'metaInfo',
      attribute: 'data-vue-meta',
      ssrAttribute: 'data-vue-meta-server-rendered',
      tagIDKeyName: 'vmid',
      refreshOnceOnNavigation: true
    })
  }
}
